import {
  CustomerEligibilityOptions,
  CustomerEligibilityStateType,
  RtoRiskStrategyOptions
} from 'src/lib/types/common/customerConditions'
import { allOptions } from 'src/@core/configs/customer-eligibilty/customer-eligibility'
import { FileTypeOptions } from 'src/lib/types/common/files'

export const customerEligibilityLabels = allOptions.reduce((acc, { label, value }) => {
  acc[value] = label
  return acc
}, {} as Record<CustomerEligibilityOptions, string>)

export const getDefaultCustomerEligibilityState = (
  newType: CustomerEligibilityOptions
): CustomerEligibilityStateType => {
  switch (newType) {
    case CustomerEligibilityOptions.ALL_CUSTOMERS:
      return { type: CustomerEligibilityOptions.ALL_CUSTOMERS }
    case CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS:
      return { type: CustomerEligibilityOptions.FIRST_TIME_CUSTOMERS }
    case CustomerEligibilityOptions.SPECIFIC_CUSTOMERS:
      return {
        type: CustomerEligibilityOptions.SPECIFIC_CUSTOMERS,
        uploadedFile: { type: FileTypeOptions.CSV, name: '', size: 0, count: 0, url: '' }
      }
    case CustomerEligibilityOptions.SPECIFIC_PINCODES:
      return {
        type: CustomerEligibilityOptions.SPECIFIC_PINCODES,
        uploadedFile: { type: FileTypeOptions.CSV, name: '', size: 0, count: 0, url: '' }
      }
    case CustomerEligibilityOptions.LIFETIME_ORDER_COUNT:
      return {
        type: CustomerEligibilityOptions.LIFETIME_ORDER_COUNT,
        minimumOrders: 1,
        maximumOrders: null
      }
    case CustomerEligibilityOptions.CUSTOMER_SEGMENT:
      return {
        type: CustomerEligibilityOptions.CUSTOMER_SEGMENT,
        segmentIds: []
      }
    case CustomerEligibilityOptions.UTM_PARAMS:
      return {
        type: CustomerEligibilityOptions.UTM_PARAMS,
        utmData: {}
      }
    case CustomerEligibilityOptions.PINCODE_RTO_RISK:
      return {
        type: CustomerEligibilityOptions.PINCODE_RTO_RISK,
        strategy: RtoRiskStrategyOptions.GREATER_THAN,
        score: 0
      }
    case CustomerEligibilityOptions.CUSTOMER_RTO_RISK:
      return {
        type: CustomerEligibilityOptions.CUSTOMER_RTO_RISK,
        strategy: RtoRiskStrategyOptions.GREATER_THAN,
        score: 0
      }
    case CustomerEligibilityOptions.ORDER_RATE_LIMIT:
      return {
        type: CustomerEligibilityOptions.ORDER_RATE_LIMIT,
        paymentMethod: '',
        maxOrders: 0,
        timePeriod: 0
      }
    default:
      return { type: CustomerEligibilityOptions.ALL_CUSTOMERS }
  }
}
